<script setup lang="ts">
// ===== 1. IMPORTS =====
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useAccountSettingsStore } from '@/stores/AccountSettingsStore'
import { useAccountSettingsPlanDetails } from '@/pages/accounts/composables/useAccountSettingsPlanDetails'

// ===== 4. EMITS =====
const emit = defineEmits<{ close: [] }>()

// ===== 5. COMPOSABLES & EXTERNAL DEPENDENCIES =====
const { t } = useI18n({ useScope: 'global' })

const { routeToPaywall } = useAccountSettingsPlanDetails()
const { subscriptionT0 } = storeToRefs(useAccountSettingsStore())

// ===== 7. COMPUTED PROPERTIES =====
const quotaText = computed(() =>
  subscriptionT0.value
    ? t('vault.maxQuotaModal.contentFree')
    : t('vault.maxQuotaModal.contentUltimate')
)

const buttonText = computed(() =>
  subscriptionT0.value
    ? t('vault.maxQuotaModal.upgradeButton')
    : t('vault.maxQuotaModal.okayButton')
)

// ===== 10. METHODS =====
function handleCta(): void {
  if (subscriptionT0.value) {
    routeToPaywall()
    emit('close')

    return
  }

  emit('close')
}

function closeModal(): void {
  emit('close')
}
</script>

<template>
  <div class="vault-max-quota-root">
    <span class="text-center">
      {{ quotaText }}
    </span>
    <footer class="flex gap-1 align-center">
      <button
        v-if="subscriptionT0"
        class="btn secondary"
        type="button"
        @click="closeModal"
      >
        {{ t('vault.maxQuotaModal.cancelButton') }}
      </button>
      <button class="btn primary" type="button" @click="handleCta">
        {{ buttonText }}
      </button>
    </footer>
  </div>
</template>

<style scoped>
.vault-max-quota-root {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
